import { render, staticRenderFns } from "./PxAcertos.vue?vue&type=template&id=3f37c5a8"
import script from "./PxAcertos.vue?vue&type=script&lang=js"
export * from "./PxAcertos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports